import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import ROUTES from '../constants';
import RouteExternal from '../RouteExternal';
import AuthenticatedRoute from '../../../pages/AuthenticatedRoute';
import { redirect as redirectDefinition, routes } from './routingDefinition';

function RoutesSelling() {
  redirectDefinition.delete(ROUTES.SELLING_PENDING);
  const { pathname } = useLocation();
  const redirectRoute = redirectDefinition.get(pathname);

  return (
    <Switch>
      {redirectRoute?.tr4 && (
        <RouteExternal exact path={pathname} link={redirectRoute.to} />
      )}
      {routes.map(({ path, authenticated, Component }) => (
        <Route path={path} key={path}>
          {authenticated ? (
            <AuthenticatedRoute component={Component} />
          ) : (
            <Component />
          )}
        </Route>
      ))}
    </Switch>
  );
}

export default RoutesSelling;
